import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { type ClipDiscussion } from '~/components/Annotations/shared/types';
import { useAnnotationV2Store } from '~/components/AnnotationsV2/providers/AnnotationV2Provider';
import { hasAnnotation } from '~/components/AnnotationsV2/shared/annotationUtils';
import { QueryParamNames } from '~/constants/search';
import { activeDiscussionIdParamSelector } from '~/store/router/selectors';
import { setQueryParams } from '~/utils/PathUtils';

export const NEW_DISCUSSION_ID = 'newDiscussionId';

/**
 * Observer that updates activeDiscussion in context based on URL param
 */
export const useActiveDiscussionIdObserver = (discussions: ClipDiscussion[]): void => {
  const activeDiscussionId = useSelector(activeDiscussionIdParamSelector);
  const setActiveDiscussion = useAnnotationV2Store((state) => state.setActiveDiscussion);

  useEffect(() => {
    if (activeDiscussionId === NEW_DISCUSSION_ID) {
      return;
    }

    if (activeDiscussionId) {
      const discussion = discussions.find((d) => d.id === activeDiscussionId);

      if (discussion) {
        // Only annotated discussions render on the canvas — keep the param for any
        // existing discussion, but only expose annotated ones to the renderer
        setActiveDiscussion(hasAnnotation(discussion) ? discussion : null);
      } else {
        // The id doesn't match any discussion, so the param is stale
        setQueryParams({ [QueryParamNames.discussionId]: null }, 'replace');
        setActiveDiscussion(null);
      }
    } else {
      setActiveDiscussion(null);
    }
  }, [activeDiscussionId, discussions, setActiveDiscussion]);
};
